import { Svg } from '@hopskipdrive/react-components';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';

import { HandoffIcon } from '../../../../../shared/components/Icons';
import { colorPalette, colorTokens } from '../../../../../shared/components/variables';

const defaultBadgeStyle = {
  display: 'inline-flex',
  minHeight: '35px',
  padding: '6px 8px',
  color: '#FFFFFF',
  border: 'none',
};

export const getSafetyBadgeProps = (badge) => {
  switch (badge) {
    case 'Must be met at drop-off':
      return {
        icon: <HandoffIcon width="16px" height="16px" style={{ color: colorTokens.text.primary }} />,
        style: {
          ...defaultBadgeStyle,
          color: colorTokens.text.primary,
          background: colorPalette.red650,
        },
      };
    case 'Can sit up front':
      return {
        icon: (
          <Svg
            icon="check-circle-outlined"
            width="16px"
            height="16px"
            style={{ color: colorTokens.primary.contrast }}
          />
        ),
        style: {
          ...defaultBadgeStyle,
          background: colorPalette.neutral400,
        },
      };
    case 'Needs booster':
      return {
        icon: (
          <AirlineSeatReclineNormalIcon width="16px" height="16px" style={{ color: colorTokens.primary.contrast }} />
        ),
        style: {
          ...defaultBadgeStyle,
          background: colorPalette.green300,
        },
      };
    default:
      return {
        style: defaultBadgeStyle,
      };
  }
};
